import React from "react";

export const IconWifi = ({ handleClick = false }) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="m15.582 14.559c-0.9867-0.8771-2.261-1.3615-3.5812-1.3615s-2.5945 0.4844-3.5813 1.3615m10.024-2.8617c-1.7476-1.6342-4.0508-2.5432-6.4434-2.5432s-4.6958 0.90905-6.4434 2.5432m15.43-3.1608c-2.4735-2.2065-5.6723-3.426-8.9869-3.426-3.3146 0-6.5134 1.2194-8.9869 3.426"
      stroke="#000"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m12 19.5c-0.2967 0-0.5867-0.088-0.8334-0.2528-0.2466-0.1648-0.4389-0.3991-0.5524-0.6732-0.1136-0.2741-0.1433-0.5757-0.0854-0.8667 0.0579-0.2909 0.2008-0.5582 0.4105-0.768 0.2098-0.2098 0.4771-0.3526 0.7681-0.4105 0.2909-0.0579 0.5925-0.0282 0.8666 0.0854 0.2741 0.1135 0.5084 0.3057 0.6732 0.5524s0.2528 0.5367 0.2528 0.8334c0 0.3978-0.158 0.7793-0.4393 1.0606s-0.6629 0.4394-1.0607 0.4394z"
      fill="#000"
    />
  </svg>
);

export default IconWifi;
